import { Box, Button, Input } from '@material-ui/core'
import { useState } from 'react'
import { getFilePreview } from 'src/util/helpers'

function VideoThumbnailField({
  imageUrl,
  onChange,
  label = 'Upload Thumbnail',
  name = 'videoThumbnail',
  id = 'contained-button-thumbnail-file',
}) {
  const [imageFile, setImageFile] = useState('')

  const handleFileOnChange = event => {
    const file = event.target.files[0]
    if (file.size > 500000) {
      alert('Maximum file size can be 500KB')
      return
    }
    setImageFile(file)
    onChange(event)
  }
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
      }}
    >
      <Box>
        {(imageFile || imageUrl) && getFilePreview(imageFile || imageUrl)}
      </Box>
      <label htmlFor={id}>
        <Input
          inputProps={{
            accept: 'image/*',
          }}
          id={id}
          type="file"
          style={{ display: 'none' }}
          name={name}
          onChange={handleFileOnChange}
        />
        <Button variant="contained" component="span">
          {label}
        </Button>
      </label>
    </Box>
  )
}

export default VideoThumbnailField
